import { useState } from 'react'
import { SecondaryButton } from '../_shared/Buttons/SecondaryButton'
import { TextInput } from '../_shared/NumberInput'
import { useMutation, useQueryClient } from 'react-query'
import { recordMileage } from '../../../../../api/api'
import { Loader } from '../_shared/Loader'

export function EditMileage({
  car,
  id,
  setShowEditMileage,
}: {
  car: any
  id: any
  setShowEditMileage: any
}) {
  const oldMileage = car.mileage
  const [mileage, setMileage] = useState(car.mileage)
  const queryClient = useQueryClient()
  const [isLoading, setIsLoading] = useState(false)
  const [success, setSuccess] = useState(false)

  const data = useMutation(
    ['changeMileage', id],
    () => recordMileage(id, Number(mileage?.replace(/\D/g, ''))),
    {
      onSuccess: () => {
        setIsLoading(false)
        setSuccess(true)
        queryClient.refetchQueries('car')
      },
      onMutate: () => {
        setIsLoading(true)
      },
    },
  )

  if (data.isError) {
    return (
      <div className="flex w-full items-center justify-center min-h-[200px] flex-col gap-6">
        <p className="text-center max-w-[40ch] leading-7">
          Noe gikk galt under oppdatering av kjørelengde. Prøv igjen senere
          eller kontakt Autoplan.
        </p>
        <SecondaryButton onClick={() => setShowEditMileage(false)}>
          Lukk vinduet
        </SecondaryButton>
      </div>
    )
  }
  if (isLoading) {
    return (
      <div className="flex w-full items-center justify-center min-h-[200px] flex-col gap-2">
        <Loader />
        <p>Oppdaterer kjørelengde...</p>
      </div>
    )
  }

  if (success) {
    return (
      <div className="flex w-full items-center justify-center min-h-[200px] flex-col gap-6">
        <p className="text-xl">Kjørelengde er oppdatert!</p>
        <SecondaryButton onClick={() => setShowEditMileage(false)}>
          Lukk vinduet
        </SecondaryButton>
      </div>
    )
  }
  return (
    <div className="flex flex-col gap-8 items-start">
      <div className="flex flex-col gap-4">
        <h3 className=" text-xl font-semibold">Oppdater kjørelengde</h3>
        <p>
          Oppdater kjørelengden på bilen for å gjøre simuleringen mer presis.
        </p>
      </div>
      <div className="w-full">
        <TextInput
          value={mileage}
          onChange={setMileage}
          id="mileage"
          label="Antall kilometer"
        />
      </div>
      <SecondaryButton onClick={() => data.mutate()}>
        Oppdater kilometerstand
      </SecondaryButton>
    </div>
  )
}
